<template>
  <div class="group-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid group-page-content">
          <div class="group-page-head">
            <div class="group-page-head-copy">
              <span class="group-eyebrow">
                <i class="fa fa-users"></i>
                Manajemen Kontak
              </span>
              <h3>Grup Kontak</h3>
              <p>Kelola dan segmentasikan kontak WhatsApp Anda dengan mudah.</p>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/index">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">Grup Kontak</li>
              </ul>
            </div>

            <a
              ref="formBc"
              href="#"
              class="btn group-btn group-btn-primary"
              data-toggle="modal"
              data-target="#add_form"
              @click="showBroadcast(true)"
            >
              <i class="fa fa-plus"></i>
              Tambah Grup
            </a>
          </div>

          <div class="group-stat-grid">
            <div class="group-stat-card">
              <span class="group-stat-icon is-blue"><i class="fa fa-users"></i></span>
              <div class="group-stat-copy">
                <span>Total Grup</span>
                <strong>
                  <i v-if="summaryLoading" class="fa fa-spinner fa-spin"></i>
                  <template v-else>{{ formatNumber(summaryGroupTotal) }}</template>
                </strong>
                <small>grup terdaftar</small>
              </div>
            </div>

            <div class="group-stat-card">
              <span class="group-stat-icon is-green"><i class="fa fa-user-plus"></i></span>
              <div class="group-stat-copy">
                <span>Total Keanggotaan Grup</span>
                <strong>
                  <i v-if="summaryLoading" class="fa fa-spinner fa-spin"></i>
                  <template v-else>{{ formatNumber(summaryMembershipTotal) }}</template>
                </strong>
                <small title="Satu kontak dapat berada di lebih dari satu grup">
                  Satu kontak dapat masuk beberapa grup
                </small>
              </div>
            </div>

            <div class="group-stat-card">
              <span class="group-stat-icon is-amber"><i class="fa fa-trophy"></i></span>
              <div class="group-stat-copy">
                <span>Grup Terbesar</span>
                <strong>
                  <i v-if="summaryLoading" class="fa fa-spinner fa-spin"></i>
                  <template v-else>
                    {{ largestGroup ? formatNumber(largestGroup.count) : "—" }}
                  </template>
                </strong>
                <small :title="largestGroup ? largestGroup.name : ''">
                  {{ largestGroup ? largestGroup.name : "Belum ada data" }}
                </small>
              </div>
            </div>
          </div>

          <div v-if="summaryError" class="group-inline-note is-warning">
            <span><i class="fa fa-exclamation-circle"></i> {{ summaryError }}</span>
            <button type="button" class="group-link-btn" :disabled="summaryLoading" @click="loadSummary">
              Coba Lagi
            </button>
          </div>
          <div v-else-if="summaryIncomplete" class="group-inline-note">
            <span>
              <i class="fa fa-info-circle"></i>
              Ringkasan anggota belum lengkap karena jumlah grup melebihi batas data yang dapat dimuat.
            </span>
            <button type="button" class="group-link-btn" :disabled="summaryLoading" @click="loadSummary">
              Muat Ulang
            </button>
          </div>

          <section class="group-card group-toolbar">
            <div class="group-toolbar-row">
              <div class="group-search">
                <i class="fa fa-search"></i>
                <input
                  v-model="serverParams.name"
                  type="text"
                  placeholder="Cari nama grup..."
                  aria-label="Cari nama grup"
                  autocomplete="off"
                  @keyup.enter="searchData"
                />
                <button
                  v-if="serverParams.name"
                  type="button"
                  class="group-search-clear"
                  title="Bersihkan pencarian"
                  aria-label="Bersihkan pencarian"
                  @click="clearSearch"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <button type="button" class="btn group-btn group-btn-primary" @click="searchData">
                <i class="fa fa-search"></i>
                Cari
              </button>
              <button type="button" class="btn group-btn group-btn-secondary" @click="reloadAll">
                <i class="fa fa-refresh"></i>
                Muat Ulang
              </button>
            </div>

            <div v-if="selectedTable.length" class="group-bulk-bar">
              <span><strong>{{ selectedTable.length }}</strong> grup dipilih</span>
              <button
                type="button"
                class="btn group-btn group-btn-danger"
                :disabled="isLoading"
                @click="actionDelete"
              >
                <i class="fa" :class="isLoading ? 'fa-spinner fa-spin' : 'fa-trash'"></i>
                Hapus Grup
              </button>
              <button type="button" class="btn group-btn group-btn-secondary" @click="hideActions">
                Batal
              </button>
            </div>
          </section>

          <section class="group-card group-table-card">
            <div class="group-table-wrap">
              <table class="table group-table mb-0">
                <thead>
                  <tr>
                    <th class="group-check-col">
                      <input
                        v-model="selectAllTable"
                        type="checkbox"
                        :disabled="loading || !rows.length"
                        title="Pilih semua grup pada halaman ini"
                        aria-label="Pilih semua grup pada halaman ini"
                      />
                    </th>
                    <th>Nama Grup</th>
                    <th class="group-description-col">Deskripsi</th>
                    <th class="group-count-col">Jumlah Kontak</th>
                    <th v-if="hasUpdateDates" class="group-updated-col">Terakhir Diperbarui</th>
                    <th class="group-action-col">Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  <template v-if="loading">
                    <tr v-for="index in 5" :key="'group-skeleton-' + index">
                      <td :colspan="tableColumnCount">
                        <div class="group-skeleton-row">
                          <span class="group-skeleton group-skeleton-check"></span>
                          <span class="group-skeleton group-skeleton-name"></span>
                          <span class="group-skeleton group-skeleton-desc"></span>
                        </div>
                      </td>
                    </tr>
                  </template>

                  <template v-else-if="rows.length">
                    <tr v-for="row in rows" :key="row.id">
                      <td class="group-check-col">
                        <input
                          v-model="selectedTable"
                          type="checkbox"
                          :value="row"
                          :aria-label="'Pilih grup ' + (row.name || '')"
                        />
                      </td>
                      <td>
                        <div class="group-name">{{ row.name || "-" }}</div>
                        <div class="group-mobile-meta">
                          <span class="group-mobile-description">
                            {{ row.description || "Tanpa deskripsi" }}
                          </span>
                          <span
                            v-if="groupUpdatedAt(row)"
                            class="group-mobile-updated"
                          >
                            Diperbarui {{ lastUpdated(row) }}
                          </span>
                        </div>
                      </td>
                      <td class="group-description-col">
                        <div class="group-description">{{ row.description || "—" }}</div>
                      </td>
                      <td class="group-count-col">
                        <router-link
                          :to="contactsLink(row)"
                          class="group-count-badge"
                          :class="countClass(row)"
                          :title="countTitle(row)"
                          :aria-label="countTitle(row)"
                          @click.stop
                        >
                          <i v-if="row.count_loading" class="fa fa-spinner fa-spin"></i>
                          <template v-else>{{ countText(row) }}</template>
                        </router-link>
                      </td>
                      <td v-if="hasUpdateDates" class="group-updated-col">
                        <span class="group-updated">{{ lastUpdated(row) }}</span>
                      </td>
                      <td class="group-action-col">
                        <div class="dropdown group-row-actions">
                          <button
                            type="button"
                            class="group-action-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            title="Aksi grup"
                            aria-label="Aksi grup"
                          >
                            <i class="fa fa-ellipsis-h"></i>
                          </button>
                          <div class="dropdown-menu dropdown-menu-right">
                            <router-link :to="contactsLink(row)" class="dropdown-item">
                              <i class="fa fa-eye text-info"></i>
                              Lihat Kontak
                            </router-link>
                            <button type="button" class="dropdown-item" @click="detailData(row.id)">
                              <i class="fa fa-pencil text-warning"></i>
                              Edit Grup
                            </button>
                            <button type="button" class="dropdown-item" @click="splitGroup(row)">
                              <i class="fa fa-users text-success"></i>
                              Pisah Grup Kontak
                            </button>
                            <!-- <router-link :to="moveLink(row)" class="dropdown-item">
                              <i class="fa fa-exchange text-primary"></i>
                              Pindahkan Kontak
                            </router-link> -->
                            <div class="dropdown-divider"></div>
                            <button
                              type="button"
                              class="dropdown-item group-danger-item"
                              @click="deleteData(row.id)"
                            >
                              <i class="fa fa-trash text-danger"></i>
                              Hapus Grup
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>

                  <tr v-else-if="!loadError">
                    <td :colspan="tableColumnCount">
                      <div class="group-empty">
                        <span class="group-empty-icon"><i class="fa fa-users"></i></span>
                        <strong>Belum ada grup kontak</strong>
                        <p>Buat grup pertama untuk mulai mengelompokkan kontak WhatsApp Anda.</p>
                        <a
                          href="#"
                          class="btn group-btn group-btn-primary"
                          data-toggle="modal"
                          data-target="#add_form"
                          @click="showBroadcast(true)"
                        >
                          <i class="fa fa-plus"></i>
                          Tambah Grup
                        </a>
                      </div>
                    </td>
                  </tr>

                  <tr v-else>
                    <td :colspan="tableColumnCount">
                      <div class="group-empty">
                        <span class="group-empty-icon is-error">
                          <i class="fa fa-exclamation-circle"></i>
                        </span>
                        <strong>Data grup belum dapat dimuat</strong>
                        <p>{{ loadError }}</p>
                        <button
                          type="button"
                          class="btn group-btn group-btn-secondary"
                          :disabled="loading"
                          @click="reloadAll"
                        >
                          <i class="fa fa-refresh"></i>
                          Coba Lagi
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="group-pagination">
              <div class="group-pagination-info">
                <span>
                  Menampilkan <strong>{{ rangeStart }}</strong>–<strong>{{ rangeEnd }}</strong>
                  dari <strong>{{ totalRecords }}</strong> grup
                </span>
                <label class="group-per-page">
                  <span>Tampilkan</span>
                  <select
                    v-model.number="serverParams.perPage"
                    aria-label="Jumlah grup per halaman"
                    @change="onPerPageChange"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="30">30</option>
                    <option :value="50">50</option>
                  </select>
                  <span>per halaman</span>
                </label>
              </div>

              <div class="group-pagination-buttons">
                <button
                  type="button"
                  class="group-page-btn"
                  :disabled="currentPage <= 1"
                  title="Halaman sebelumnya"
                  aria-label="Halaman sebelumnya"
                  @click="onPrevChange"
                >
                  <i class="fa fa-angle-left"></i>
                </button>
                <button
                  v-for="page in pageNumbers"
                  :key="'group-page-' + page"
                  type="button"
                  class="group-page-btn"
                  :class="{ active: page === currentPage }"
                  :aria-current="page === currentPage ? 'page' : null"
                  @click="onPageChange(page)"
                >
                  {{ page }}
                </button>
                <button
                  type="button"
                  class="group-page-btn"
                  :disabled="currentPage >= totalPages"
                  title="Halaman berikutnya"
                  aria-label="Halaman berikutnya"
                  @click="onNextChange"
                >
                  <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </section>

          <div class="group-page-note">
            <i class="fa fa-info-circle"></i>
            Klik jumlah kontak pada sebuah grup untuk membuka daftar kontak yang sudah difilter.
            Gunakan menu tiga titik untuk mengedit, memisah, memindahkan, atau menghapus grup.
          </div>
        </div>
      </div>
    </div>

    <a
      v-show="false"
      ref="formBcEdit"
      href="#"
      data-toggle="modal"
      data-target="#add_form"
      @click="showBroadcast(false)"
    >
      Edit
    </a>

    <form-data :searchData="refreshGroupData" />
    <form-split-group
      ref="splitGroup"
      v-model="selectedGroup"
      @searchData="refreshGroupData"
    />
  </div>
</template>

<script>
import FormData from "./form.vue";
import FormSplitGroup from "./formSplitGroup.vue";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    FormData,
    FormSplitGroup
  },
  data() {
    return {
      selectedTable: [],
      selectedGroup: null,
      isLoading: false,
      loading: false,
      loadError: "",
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      serverParams: {
        name: "",
        perPage: 20
      },
      summaryLoading: false,
      summaryError: "",
      summaryIncomplete: false,
      summaryGroupTotal: null,
      summaryMembershipTotal: null,
      largestGroup: null,
      groupCountCache: {},
      listRequestId: 0,
      summaryRequestId: 0
    };
  },
  computed: {
    selectAllTable: {
      get() {
        return this.rows.length > 0 && this.selectedTable.length === this.rows.length;
      },
      set(value) {
        this.selectedTable = value ? this.rows.slice() : [];
      }
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRecords / this.serverParams.perPage));
    },
    rangeStart() {
      if (!this.totalRecords) {
        return 0;
      }
      return (this.currentPage - 1) * this.serverParams.perPage + 1;
    },
    rangeEnd() {
      return Math.min(this.currentPage * this.serverParams.perPage, this.totalRecords);
    },
    pageNumbers() {
      const total = this.totalPages;
      const current = this.currentPage;
      const max = 5;
      let start = Math.max(1, current - 2);
      let end = Math.min(total, start + max - 1);
      start = Math.max(1, end - max + 1);
      const pages = [];
      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }
      return pages;
    },
    hasUpdateDates() {
      return this.rows.some(row => this.groupUpdatedAt(row) !== null);
    },
    tableColumnCount() {
      return this.hasUpdateDates ? 6 : 5;
    }
  },
  created() {
    this.loadItems();
    this.loadSummary();
  },
  methods: {
    formatNumber(value) {
      if (value === null || typeof value === "undefined" || value === "") {
        return "—";
      }
      const numeric = Number(value);
      if (!isFinite(numeric)) {
        return "—";
      }
      return numeric.toLocaleString("id-ID");
    },
    getErrorMessage(error, fallback) {
      let message = "";
      if (error && error.response && error.response.data) {
        message = error.response.data.msg || error.response.data.message || "";
      }
      if (!message && error && error.message) {
        message = error.message;
      }
      message = String(message)
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
      if (!message) {
        return fallback;
      }
      if (/sql|select |table|column|backend|redis|worker|stack|trace|invalid|failed|error/i.test(message)) {
        return fallback;
      }
      return message;
    },
    clearSelection() {
      this.selectedTable = [];
    },
    hideActions() {
      this.clearSelection();
    },
    clearSearch() {
      this.serverParams.name = "";
      this.searchData();
    },
    contactsLink(row) {
      return {
        path: "/contacts-v2",
        query: {
          filter: "group",
          group_id: String(row.id),
          group_name: row.name || ""
        }
      };
    },
    moveLink(row) {
      return {
        path: "/contacts-v2",
        query: {
          filter: "group",
          group_id: String(row.id),
          group_name: row.name || "",
          action: "move"
        }
      };
    },
    groupUpdatedAt(row) {
      if (!row) {
        return null;
      }
      const value =
        row.update_datetime ||
        row.updated_at ||
        row.updated_datetime ||
        row.update_date ||
        row.update_time ||
        row.update_at ||
        row.modified_at ||
        row.last_updated ||
        row.last_update;
      return value || null;
    },
    lastUpdated(row) {
      const value = this.groupUpdatedAt(row);
      if (!value) {
        return "—";
      }
      if (typeof value === "number" || /^\d+$/.test(String(value))) {
        const numeric = Number(value);
        const unix = numeric > 9999999999 ? Math.floor(numeric / 1000) : numeric;
        const date = new Date(unix * 1000);
        if (!isNaN(date.getTime())) {
          return date.toLocaleString("id-ID", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
          });
        }
      }
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString("id-ID", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        });
      }
      return String(value);
    },
    countText(row) {
      if (row && row.total_group !== null && typeof row.total_group !== "undefined") {
        return this.formatNumber(row.total_group);
      }
      return "—";
    },
    countClass(row) {
      if (row && row.total_group !== null && typeof row.total_group !== "undefined") {
        return Number(row.total_group) > 0 ? "is-green" : "is-neutral";
      }
      return "is-muted";
    },
    countTitle(row) {
      if (row && row.count_loading) {
        return "Memuat jumlah kontak grup ini";
      }
      if (row && row.total_group !== null && typeof row.total_group !== "undefined") {
        return "Lihat " + this.formatNumber(row.total_group) + " kontak pada grup " + (row.name || "");
      }
      return "Lihat kontak grup " + (row.name || "");
    },
    getGroupCount(groupId) {
      const key = String(groupId);
      if (this.groupCountCache[key]) {
        return this.groupCountCache[key];
      }
      this.groupCountCache[key] = this.$store
        .dispatch("contact/countContactByGroupId", groupId)
        .then(response => Number(response.data) || 0)
        .catch(() => {
          delete this.groupCountCache[key];
          return null;
        });
      return this.groupCountCache[key];
    },
    async loadItems() {
      const requestId = this.listRequestId + 1;
      this.listRequestId = requestId;
      this.loading = true;
      this.loadError = "";
      this.clearSelection();
      this.rows = [];
      const params = {
        name: this.serverParams.name,
        page: Math.max(0, (this.currentPage - 1) * this.serverParams.perPage),
        perPage: this.serverParams.perPage
      };

      try {
        const response = await this.$store.dispatch("contact/getGroupListV2", params);
        if (requestId !== this.listRequestId) {
          return;
        }
        const data = (response && response.data) || {};
        this.totalRecords = Number(data.totalRecords) || 0;
        const rows = Array.isArray(data.data) ? data.data : [];
        rows.forEach(row => {
          this.$set(row, "count_loading", true);
          this.$set(row, "total_group", undefined);
        });
        this.rows = rows;
        rows.forEach(row => {
          this.getGroupCount(row.id).then(count => {
            if (requestId !== this.listRequestId) {
              return;
            }
            this.$set(row, "count_loading", false);
            this.$set(row, "total_group", count === null ? null : count);
          });
        });
      } catch (error) {
        if (requestId === this.listRequestId) {
          this.loadError = this.getErrorMessage(
            error,
            "Daftar grup belum dapat dimuat. Coba lagi."
          );
          this.totalRecords = 0;
        }
      } finally {
        if (requestId === this.listRequestId) {
          this.loading = false;
        }
      }
    },
    async loadSummary() {
      const requestId = this.summaryRequestId + 1;
      this.summaryRequestId = requestId;
      this.summaryLoading = true;
      this.summaryError = "";
      this.summaryIncomplete = false;
      this.summaryMembershipTotal = null;
      this.largestGroup = null;

      try {
        const response = await this.$store.dispatch("contact/getGroupListV2", {
          name: "",
          page: 0,
          perPage: 500
        });
        if (requestId !== this.summaryRequestId) {
          return;
        }
        const data = (response && response.data) || {};
        const groups = Array.isArray(data.data) ? data.data : [];
        this.summaryGroupTotal = Number(data.totalRecords) || groups.length;
        if (groups.length < this.summaryGroupTotal) {
          this.summaryIncomplete = true;
          return;
        }
        if (!groups.length) {
          this.summaryMembershipTotal = 0;
          this.largestGroup = null;
          return;
        }

        const counts = [];
        for (let index = 0; index < groups.length; index += 8) {
          const batch = groups.slice(index, index + 8);
          const results = await Promise.all(batch.map(group => this.getGroupCount(group.id)));
          counts.push(...results);
        }
        if (requestId !== this.summaryRequestId) {
          return;
        }
        if (counts.some(count => count === null)) {
          this.summaryError = "Sebagian jumlah kontak grup belum dapat dimuat.";
          return;
        }

        let total = 0;
        let largest = null;
        groups.forEach((group, index) => {
          const count = counts[index] || 0;
          total += count;
          if (!largest || count > largest.count) {
            largest = { id: group.id, name: group.name || "-", count };
          }
        });
        this.summaryMembershipTotal = total;
        this.largestGroup = largest && largest.count > 0 ? largest : null;
      } catch (error) {
        if (requestId === this.summaryRequestId) {
          this.summaryError = this.getErrorMessage(
            error,
            "Ringkasan grup belum dapat dimuat."
          );
        }
      } finally {
        if (requestId === this.summaryRequestId) {
          this.summaryLoading = false;
        }
      }
    },
    searchData() {
      this.currentPage = 1;
      this.clearSelection();
      this.loadItems();
    },
    async onPageChange(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) {
        return;
      }
      this.currentPage = page;
      this.clearSelection();
      await this.loadItems();
    },
    onNextChange() {
      if (this.currentPage < this.totalPages) {
        this.onPageChange(this.currentPage + 1);
      }
    },
    onPrevChange() {
      if (this.currentPage > 1) {
        this.onPageChange(this.currentPage - 1);
      }
    },
    onPerPageChange() {
      this.serverParams.perPage = Number(this.serverParams.perPage) || 20;
      this.currentPage = 1;
      this.clearSelection();
      this.loadItems();
    },
    reloadAll() {
      this.groupCountCache = {};
      this.clearSelection();
      this.loadItems();
      this.loadSummary();
    },
    refreshGroupData() {
      this.groupCountCache = {};
      this.currentPage = 1;
      this.clearSelection();
      this.loadItems();
      this.loadSummary();
    },
    async detailData(id) {
      if (!id) {
        return;
      }
      try {
        this.$store.dispatch("contact/setIsShowForm", false);
        const response = await this.$store.dispatch("contact/detailGroup", id);
        const formData = Object.assign({}, (response && response.data) || {});
        formData.id = id;
        await this.$store.dispatch("contact/actFormParamGroupSt", formData);
        if (this.$refs.formBcEdit) {
          this.$refs.formBcEdit.click();
        }
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.getErrorMessage(error, "Data grup belum dapat dimuat."),
          type: "error",
          timer: 3000
        });
      }
    },
    async splitGroup(row) {
      if (!row || !row.id) {
        return;
      }
      let count = row.total_group;
      if (count === null || typeof count === "undefined" || row.count_loading) {
        count = await this.getGroupCount(row.id);
        if (count === null) {
          this.$fire({
            title: "Gagal",
            text: "Jumlah kontak grup belum dapat dimuat.",
            type: "error",
            timer: 3000
          });
          return;
        }
        this.$set(row, "total_group", count);
        this.$set(row, "count_loading", false);
      }
      this.selectedGroup = Object.assign({}, row, { total_group: Number(count) || 0 });
      if (this.$refs.splitGroup) {
        this.$refs.splitGroup.showDialog();
      }
    },
    async deleteData(id) {
      if (!id) {
        return;
      }
      const confirmation = await this.$fire({
        title: "Hapus grup ini?",
        text:
          "Grup akan dihapus permanen. Kontak di dalamnya tetap tersimpan di akun dan tidak ikut dihapus.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Hapus Grup",
        cancelButtonText: "Batal",
        confirmButtonColor: "#d92d20"
      });
      if (!this.isConfirmed(confirmation)) {
        return;
      }
      try {
        const response = await this.$store.dispatch("contact/removeGroup", {
          group_id: id
        });
        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || "Grup berhasil dihapus.",
          type: "success",
          timer: 3000
        });
        this.refreshGroupData();
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.getErrorMessage(error, "Grup belum dapat dihapus."),
          type: "error",
          timer: 3000
        });
      }
    },
    async actionDelete() {
      if (!this.selectedTable.length) {
        this.$fire({
          title: "Peringatan",
          text: "Pilih minimal satu grup yang akan dihapus.",
          type: "warning",
          timer: 3000
        });
        return;
      }
      this.isLoading = true;
      const count = this.selectedTable.length;
      try {
        const confirmation = await this.$fire({
          title: "Hapus " + count + " grup terpilih?",
          text:
            "Grup akan dihapus permanen. Kontak di dalamnya tetap tersimpan di akun dan tidak ikut dihapus.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Hapus Grup",
          cancelButtonText: "Batal",
          confirmButtonColor: "#d92d20"
        });
        if (!this.isConfirmed(confirmation)) {
          this.isLoading = false;
          return;
        }
        const response = await this.$store.dispatch("contact/deleteGroupSelected", {
          id: this.selectedTable
        });
        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || count + " grup berhasil dihapus.",
          type: "success",
          timer: 3000
        });
        this.clearSelection();
        this.refreshGroupData();
      } catch (error) {
        this.$fire({
          title: "Gagal",
          text: this.getErrorMessage(error, "Grup belum dapat dihapus."),
          type: "error",
          timer: 3000
        });
      } finally {
        this.isLoading = false;
      }
    },
    isConfirmed(result) {
      return Boolean(result && (result.isConfirmed || result.value === true));
    },
    showBroadcast(newData) {
      if (newData === true) {
        this.$store.dispatch("contact/setIsShowForm", false);
        this.$store.dispatch("contact/actFormParamGroupSt", {
          id: "",
          name: "",
          description: ""
        });
      }
      setTimeout(() => {
        const modal = document.getElementById("add_form");
        if (modal && modal.classList.contains("show")) {
          this.$store.dispatch("contact/setIsShowForm", true);
        }
      }, 500);
    }
  },
  name: "group-list"
};
</script>

<style scoped>
.group-page-content {
  padding-bottom: 32px;
  color: #344054;
}

.group-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.group-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 6px;
  color: #b36b00;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.group-page-head-copy h3 {
  margin: 0 0 6px;
  color: #101828;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
}

.group-page-head-copy p {
  margin: 0 0 9px;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}

.group-page-head-copy .breadcrumb {
  margin: 0;
  padding: 0;
  background: transparent;
  font-size: 13px;
}

.group-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 38px;
  padding: 0 14px;
  border-radius: 9px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.group-btn-primary {
  color: #ffffff;
  background: #f39c12;
  border-color: #f39c12;
  box-shadow: 0 3px 8px rgba(243, 156, 18, 0.18);
}

.group-btn-primary:hover,
.group-btn-primary:focus {
  color: #ffffff;
  background: #e08b13;
  border-color: #e08b13;
}

.group-btn-secondary {
  color: #475467;
  background: #ffffff;
  border-color: #e7edf5;
}

.group-btn-secondary:hover,
.group-btn-secondary:focus {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
}

.group-btn-danger {
  color: #ffffff;
  background: #d92d20;
  border-color: #d92d20;
}

.group-btn-danger:hover,
.group-btn-danger:focus {
  color: #ffffff;
  background: #b42318;
  border-color: #b42318;
}

.group-stat-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}

.group-stat-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.group-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: 11px;
  font-size: 17px;
}

.group-stat-icon.is-blue { color: #2e90fa; background: #eff8ff; }
.group-stat-icon.is-green { color: #12b76a; background: #ecfdf3; }
.group-stat-icon.is-amber { color: #d98314; background: #fff7e8; }

.group-stat-copy {
  min-width: 0;
}

.group-stat-copy > span {
  display: block;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
}

.group-stat-copy > strong {
  display: block;
  margin: 2px 0;
  color: #101828;
  font-size: 25px;
  line-height: 1.2;
  font-weight: 700;
  word-break: break-word;
}

.group-stat-copy > small {
  display: block;
  overflow: hidden;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-card {
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.group-toolbar {
  margin-bottom: 16px;
  padding: 14px;
}

.group-toolbar-row {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
}

.group-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 300px;
  min-width: 220px;
  height: 40px;
  padding: 0 11px;
  color: #98a2b3;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 9px;
}

.group-search > i {
  flex: 0 0 auto;
  font-size: 14px;
}

.group-search input {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0 8px;
  color: #344054;
  background: transparent;
  border: 0;
  outline: none;
  font-size: 14px;
}

.group-search input::placeholder { color: #98a2b3; }

.group-search-clear {
  flex: 0 0 auto;
  padding: 3px;
  color: #98a2b3;
  background: transparent;
  border: 0;
  font-size: 13px;
}

.group-search-clear:hover { color: #b42318; }

.group-bulk-bar {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding: 10px 12px;
  background: #fffaf1;
  border: 1px solid #f6d49b;
  border-radius: 10px;
  color: #8f5600;
  font-size: 13px;
}

.group-bulk-bar > span { flex: 1 1 auto; }
.group-bulk-bar strong { color: #b36b00; }

.group-inline-note {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 10px 14px;
  color: #475467;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
  font-size: 13px;
}

.group-inline-note.is-warning {
  color: #8a5a00;
  background: #fff8e6;
  border-color: #f3d28d;
}

.group-inline-note.is-error {
  color: #a71d2a;
  background: #fff5f5;
  border-color: #f5b5b5;
}

.group-link-btn {
  padding: 0;
  color: inherit;
  background: transparent;
  border: 0;
  font-weight: 700;
  text-decoration: underline;
}

.group-table-card {
  overflow: visible;
}

.group-table-wrap {
  overflow: visible;
}

.group-table {
  min-width: 900px;
  margin-bottom: 0;
  color: #475467;
  font-size: 14px;
  line-height: 1.45;
}

.group-table thead th {
  padding: 12px 14px;
  color: #667085;
  background: #f8fafc;
  border-top: 0;
  border-bottom: 1px solid #e7edf5;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
}

.group-table tbody td {
  padding: 15px 14px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f4f8;
}

.group-table tbody tr:last-child td { border-bottom: 0; }
.group-table tbody tr:hover { background: #fffdf9; }

.group-check-col {
  width: 44px;
  text-align: center;
}

.group-check-col input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.group-name {
  color: #344054;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  word-break: break-word;
}

.group-description {
  max-width: 360px;
  color: #667085;
  font-size: 13px;
  line-height: 1.45;
  word-break: break-word;
}

.group-mobile-meta {
  display: none;
}

.group-count-col { width: 140px; }

.group-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  padding: 4px 10px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.group-count-badge.is-green {
  color: #067647;
  background: #ecfdf3;
  border-color: #bbf7d0;
}

.group-count-badge.is-green:hover,
.group-count-badge.is-green:focus {
  color: #05603a;
  background: #d1fadf;
  border-color: #a6f4c5;
}

.group-count-badge.is-neutral,
.group-count-badge.is-muted {
  color: #667085;
  background: #f8fafc;
  border-color: #e7edf5;
}

.group-count-badge.is-neutral:hover,
.group-count-badge.is-neutral:focus,
.group-count-badge.is-muted:hover,
.group-count-badge.is-muted:focus {
  color: #475467;
  background: #f2f4f7;
}

.group-updated {
  color: #667085;
  font-size: 13px;
  white-space: nowrap;
}

.group-action-col {
  width: 72px;
  text-align: right;
}

.group-row-actions {
  display: inline-block;
}

.group-action-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  font-size: 15px;
}

.group-action-toggle:hover,
.group-action-toggle:focus {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
  outline: none;
}

.group-row-actions .dropdown-menu {
  min-width: 230px;
  padding: 7px;
  border: 1px solid #e7edf5;
  border-radius: 12px;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.16);
}

.group-row-actions .dropdown-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 9px 10px;
  color: #475467;
  border-radius: 8px;
  font-size: 13px;
}

.group-row-actions .dropdown-item:hover,
.group-row-actions .dropdown-item:focus {
  color: #b36b00;
  background: #fffaf1;
}

.group-row-actions .group-danger-item { color: #b42318; }
.group-row-actions .group-danger-item:hover,
.group-row-actions .group-danger-item:focus { color: #912018; background: #fff1f0; }

.group-skeleton-row {
  display: flex;
  align-items: center;
  gap: 18px;
}

.group-skeleton {
  display: block;
  height: 16px;
  background: #eef2f6;
  border-radius: 6px;
}

.group-skeleton-check { width: 16px; height: 16px; }
.group-skeleton-name { width: 180px; }
.group-skeleton-desc { width: 260px; }

.group-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 46px 16px;
  text-align: center;
}

.group-empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 12px;
  color: #e08b13;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 50%;
  font-size: 21px;
}

.group-empty-icon.is-error {
  color: #b42318;
  background: #fff1f0;
  border-color: #f5b5b5;
}

.group-empty strong {
  margin-bottom: 4px;
  color: #344054;
  font-size: 17px;
}

.group-empty p {
  max-width: 410px;
  margin: 0 0 15px;
  color: #667085;
  font-size: 13px;
}

.group-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  padding: 14px 16px;
  border-top: 1px solid #f1f4f8;
}

.group-pagination-info {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  color: #667085;
  font-size: 13px;
}

.group-pagination-info strong { color: #344054; }

.group-per-page {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-weight: 400;
}

.group-per-page select {
  height: 32px;
  padding: 0 24px 0 9px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 8px;
  font-size: 13px;
}

.group-pagination-buttons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.group-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}

.group-page-btn:hover:not(:disabled),
.group-page-btn:focus:not(:disabled) {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f6d49b;
  outline: none;
}

.group-page-btn.active {
  color: #ffffff;
  background: #f39c12;
  border-color: #f39c12;
}

.group-page-btn:disabled {
  color: #b8c0cc;
  background: #f8fafc;
  cursor: not-allowed;
}

.group-page-note {
  margin-top: 14px;
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
}

.group-page-note i { color: #2e90fa; margin-right: 5px; }

@media (max-width: 1200px) {
  .group-table-wrap {
    overflow-x: auto;
  }
}

@media (max-width: 991px) {
  .group-stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .group-row-actions .dropdown-menu {
    position: fixed !important;
    top: auto !important;
    right: 12px !important;
    bottom: 12px !important;
    left: 12px !important;
    width: auto !important;
    min-width: 0 !important;
    max-height: calc(100vh - 24px);
    margin: 0 !important;
    overflow-y: auto;
    transform: none !important;
    z-index: 1080;
  }
}

@media (max-width: 767px) {
  .group-page-head {
    flex-direction: column;
  }

  .group-page-head .group-btn-primary {
    align-self: flex-start;
  }

  .group-stat-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .group-toolbar-row {
    align-items: stretch;
  }

  .group-search {
    flex-basis: 100%;
  }

  .group-toolbar-row .group-btn {
    flex: 1 1 auto;
  }

  .group-pagination {
    align-items: flex-start;
    flex-direction: column;
  }

  .group-pagination-buttons {
    flex-wrap: wrap;
  }

  .group-table-wrap {
    overflow: visible;
  }

  .group-table {
    width: 100%;
    min-width: 0;
  }

  .group-table thead th,
  .group-table tbody td {
    padding: 11px 7px;
  }

  .group-table .group-description-col,
  .group-table .group-updated-col {
    display: none;
  }

  .group-mobile-meta {
    display: block;
    margin-top: 3px;
    color: #667085;
    font-size: 12px;
    line-height: 1.4;
  }

  .group-mobile-description {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .group-mobile-updated {
    display: block;
    margin-top: 2px;
    color: #98a2b3;
    font-size: 11px;
  }

  .group-check-col {
    width: 32px;
  }

  .group-table th.group-count-col,
  .group-table td.group-count-col {
    position: sticky;
    right: 48px;
    z-index: 2;
    width: 72px;
    min-width: 72px;
    background: #ffffff;
    box-shadow: -7px 0 8px -8px rgba(15, 23, 42, 0.25);
  }

  .group-table th.group-action-col,
  .group-table td.group-action-col {
    position: sticky;
    right: 0;
    z-index: 3;
    width: 48px;
    min-width: 48px;
    background: #ffffff;
    box-shadow: -7px 0 8px -8px rgba(15, 23, 42, 0.25);
  }

  .group-count-badge {
    min-width: 44px;
    padding: 3px 8px;
    font-size: 12px;
  }

  .group-action-toggle {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .group-table thead th.group-count-col,
  .group-table thead th.group-action-col {
    background: #f8fafc;
  }

  .group-table tbody tr:hover td.group-count-col,
  .group-table tbody tr:hover td.group-action-col {
    background: #fffdf9;
  }
}

@media (max-width: 480px) {
  .group-page-head-copy h3 {
    font-size: 24px;
  }

  .group-stat-copy > strong {
    font-size: 22px;
  }

  .group-pagination-info {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .group-per-page {
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/crm/group/list.vue